import { store } from '../../store';
import { updateThinkingStatus } from '../../store/chat/slice';
import { ConversationStatus } from '../../store/chat/types';
import { SocketMessage } from '../types';

export interface ThinkingUpdatePayload {
  conversationId: string;
  userMessageSequence: number;
  thinkingStatus: string;
}

/**
 * Handler for thinking status updates received via websocket
 * Updates the thinking status in Redux
 */
export function thinkingUpdateHandler(message: SocketMessage<ThinkingUpdatePayload>): void {
  const payload = message.payload as ThinkingUpdatePayload;

  if (
    !payload ||
    !payload.conversationId ||
    payload.userMessageSequence === undefined ||
    !payload.thinkingStatus
  ) {
    console.error('Invalid thinking update payload:', payload);
    return;
  }

  const { conversationId, userMessageSequence, thinkingStatus } = payload;

  const state = store.getState();
  const currentConversation = state.chat.conversation;

  if (
    currentConversation &&
    currentConversation.id === conversationId &&
    currentConversation.status === ConversationStatus.Answering
  ) {
    store.dispatch(
      updateThinkingStatus({
        conversationId,
        userMessageSequence,
        thinkingStatus,
      }),
    );
  }
}
